/*
  EDDIA — shipping message (snippets/eddia-kargo-mesaj.liquid), 2026-10-01.
  The message itself is rendered by Liquid (and re-rendered by the theme whenever the cart changes). This script only
  does what Liquid cannot:
   1. On the cart page the shipping estimator has its own country select — when the customer picks a country there,
      the message follows it.
   2. The estimator asks Shopify for shipping rates WITHOUT discounts, so it showed "USD 10.00" for 5 pairs to the US
      while checkout charged $0. For US/UK carts of 5+ items the estimator line now reads FREE (applied at checkout);
      for 1–4 items it adds how many more are needed.
*/
(() => {
  if (customElements.get('eddia-kargo')) return;
  const ESIK = ['US', 'GB'];

  const THE = ['US', 'GB', 'NL', 'AE', 'PH', 'DO', 'BS', 'GM', 'CF', 'KY', 'FO', 'MV', 'SC', 'SB', 'MH', 'VG', 'VI', 'CK', 'FK', 'TC', 'CC', 'CX', 'KM'];

  const metinYap = (ayar, ulke, ad, adet, toptan) => {
    const ar = ayar.ar, para = (c) => '$' + Math.round(c / 100);
    if (!ar && THE.includes(ulke)) ad = 'the ' + ad;   // "Shipping to the United States"
    if (toptan) return ar ? 'الشحن مجاني لطلبات الجملة إلى جميع أنحاء العالم.' : '<strong>Free worldwide shipping</strong> on wholesale orders.';
    if (ulke === 'TR') return ar ? `<strong>شحن مجاني</strong> إلى ${ad}.` : `<strong>Free shipping</strong> to ${ad}.`;
    if (ESIK.includes(ulke)) {
      if (adet >= 5) return ar ? `<strong>شحن مجاني</strong> إلى ${ad} — طلبك يضم 5 قطع أو أكثر. يُطبَّق عند الدفع.` : `<strong>Your order ships FREE</strong> to ${ad} — 5+ items. Applied at checkout.`;
      const k = 5 - adet;
      return ar ? `الشحن إلى ${ad}: ${para(1000)}. أضف <strong>${k}</strong> ${k === 1 ? 'قطعة أخرى' : 'قطع أخرى'} ليصبح <strong>الشحن مجانياً</strong>.`
        : `Shipping to ${ad}: ${para(1000)}. Add <strong>${k} more ${k === 1 ? 'item' : 'items'}</strong> for <strong>FREE shipping</strong>.`;
    }
    const ucret = ulke === 'CA' ? 3500 : ayar.ab.includes(ulke) ? 1500 : 4500;
    return ar ? `الشحن إلى ${ad}: ${para(ucret)} سعر ثابت.` : `Shipping to ${ad}: ${para(ucret)} flat rate.`;
  };

  class EddiaKargo extends HTMLElement {
    connectedCallback() {
      if (this._hazir) return; this._hazir = true;
      this.ayar = JSON.parse(this.querySelector('[data-kargo-ayar]')?.textContent || '{}');
      this.adet = Number(this.dataset.adet || 0);
      this.toptan = this.dataset.toptan === 'true';
      if (this.dataset.yer !== 'sepet') return;
      // the cart page: follow the estimator's country, fix its US/UK line
      const tahmin = document.querySelector('shipping-estimator');
      if (!tahmin) return;
      const secim = tahmin.querySelector('[name="address[country]"]');
      const kod = () => this.ayar.adlar?.[secim?.value] || this.dataset.ulke;
      const guncelle = () => {
        const u = kod(); if (!u) return;
        this.querySelector('[data-kargo-metin]').innerHTML = metinYap(this.ayar, u, secim.value, this.adet, this.toptan);
        const cubuk = this.querySelector('[data-kargo-cubuk]');
        if (cubuk) cubuk.hidden = !(ESIK.includes(u) && this.adet < 5 && !this.toptan);
      };
      secim?.addEventListener('change', guncelle);
      const sonuc = tahmin.querySelector('[aria-live="polite"]');
      if (sonuc) {
        const duzelt = () => {
          if (!ESIK.includes(kod()) || this.toptan) return;
          for (const li of sonuc.querySelectorAll('li:not([data-eddia])')) {
            li.dataset.eddia = '1';
            const ad = li.textContent.split(':')[0];
            if (this.adet >= 5) li.innerHTML = `${ad}: <strong>FREE</strong> <s class="text-subdued">${li.textContent.split(':').slice(1).join(':').trim()}</s> — 5+ items, applied at checkout`;
            else li.insertAdjacentHTML('beforeend', ` — add ${5 - this.adet} more ${5 - this.adet === 1 ? 'item' : 'items'} for FREE shipping`);
          }
        };
        new MutationObserver(duzelt).observe(sonuc, { childList: true, subtree: true });
      }
      if (secim && secim.value && this.ayar.adlar?.[secim.value] && this.ayar.adlar[secim.value] !== this.dataset.ulke) guncelle();
    }
  }
  customElements.define('eddia-kargo', EddiaKargo);
})();
